import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import api from "../../../api";
import apiFunctions from "../../../api/functions.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback, Alert } from 'reactstrap';
import moment from 'moment';
import { formatCurrency } from '../../../functions/functions';

import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable.js"

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"

import { createPortal } from 'react-dom';

class ModalCuentaCorriente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comitente_id: null,
            postVariables: [],
            errors: [],
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => (d.fecha) ? (moment(d.fecha).format('DD-MM-YYYY')) : (''),
                    width: 120,
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Detalle",
                    id: "detalle",
                    accessor: "detalle",
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Encomienda",
                    id: "encomienda",
                    accessor: d => d.encomiendaProfesional ? d.encomiendaProfesional.nroOrden : '',
                    width: 120,
                    show: true,
                    filterable: false,
                    ignoreAsField: true,
                },
                {
                    Header: "Egreso",
                    id: "egreso",
                    accessor: d => formatCurrency(d.egreso),
                    className: "text-right",
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Ingreso",
                    id: "ingreso",
                    accessor: d => formatCurrency(d.ingreso),
                    className: "text-right",
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Saldo",
                    id: "subtotal",
                    accessor: d => formatCurrency(d.subtotal),
                    className: "text-right",
                    show: true,
                    filterable: false,
                },
            ],
            sinaplicar: '0,00',
            totalDeuda: '0,00',
            totalPagos: '0,00',
            saldo: '0,00',
        };
        this.tableRef = React.createRef();
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            comitente_id: null,
            sinaplicar: '0,00',
            totalDeuda: '0,00',
            totalPagos: '0,00',
            saldo: '0,00',
        });
    }

    getData() {
        const { action } = this.props;
        const { postVariables, fecha, importe, aplicacionesEncomienda } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.fecha = fecha.format('YYYY-MM-DDThh:mm');
        data.importe = parseFloat(importe.replace(',', '.'));

        if (aplicacionesEncomienda.filter(e => e.isChecked == true).length > 0) {
            data['aplicacionesEncomienda'] = aplicacionesEncomienda.filter(e => e.isChecked == true).map(d => {
                return {
                    encomiendaProfesional_id: d.encomiendaProfesional.id,
                    importe: parseFloat(d.importe.replace(',', '.'))
                }
            })
        }

        return data;
    }

    setData(data) {
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "DETAIL") {
            return {
                get: false,
                title: "Cuenta Corriente",
                buttonTitle: "Cta. Cte.",
                danger: false,
                buttonIcon: "fa fa-usd fa-lg",
                successMessage: "ha sido editado con éxito.",
                saveButton: false,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: true,
                cancelButtonLabel: 'Volver',
            };
        }
        return {
            get: false,
            title: "Cuenta Corriente",
            buttonTitle: "Cta. Cte.",
            danger: false,
            buttonIcon: "fa fa-usd fa-lg",
            successMessage: "ha sido editado con éxito.",
            saveButton: false,
            saveButtonLabel: "Guardar",
            buttonClass: "",
            disabled: true,
            cancelButtonLabel: 'Volver',
        };
    }

    onOpen = () => {
        this.setState({
            comitente_id: this.props.id(),
            totalDeuda: '0,00',
            totalPagos: '0,00',
            saldo: '0,00',
        })
        this.traerCobroAplicacion();
    }

    traerCobroAplicacion = (id) => {
        apiFunctions.get(api.cuentasCorrientes.totalAplicacionesEIngresos, null, null, null, (response) => {
            this.setState({
                sinaplicar: formatCurrency(response.data.saldoRestante),
            });
        }, (response) => {
            this.setState({
                sinaplicar: '0,00',
            });
        });

        this.calculateTotals();
    }

    calculateTotals = () => {
        const params = {
            paginationEnabled: false,
        };

        apiFunctions.get(api.cuentasCorrientes.movimientos, null, null, params, (response) => {
            let totalDeuda = 0;
            let totalPagos = 0;

            if (response.data && response.data.length > 0) {
                response.data.forEach(row => {
                    totalDeuda += parseFloat(row.egreso) || 0;
                    totalPagos += parseFloat(row.ingreso) || 0;
                });
            }

            const saldo = totalPagos - totalDeuda;

            this.setState({
                totalDeuda: formatCurrency(totalDeuda.toString().replace('.', ',')),
                totalPagos: formatCurrency(totalPagos.toString().replace('.', ',')),
                saldo: formatCurrency(saldo.toString().replace('.', ',')),
            });
        }, (error) => {
            this.setState({
                totalDeuda: '0,00',
                totalPagos: '0,00',
                saldo: '0,00',
            });
        });
    }

    render() {
        let vars = this.modalVars();
        const { action, asUsuarios } = this.props;
        const { comitente_id, sinaplicar, totalDeuda, totalPagos, saldo } = this.state;
        const outerSort = [
            {
                id: 'fecha',
                desc: true
            },
        ];

        const outerFilter = []

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.cuentasCorrientes.cobroAplicacion : null)}
                submitUrl={(vars.submitType ? api.cuentasCorrientes.cobroAplicacion : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}
                onOpen={() => this.onOpen()}

                cancelButtonLabel={vars.cancelButtonLabel}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                escClose={true}

                className={'modal-lg'}
            >
                <Row>
                    <Col className={'col-12 t_ctacte'} style={comitente_id == null ? { filter: 'blur(2px)', pointerEvents: 'none' } : {}}>
                        <ParadigmaTable
                            ref={this.tableRef}
                            buttons={[]}
                            apiUrl={api.cuentasCorrientes.movimientos}
                            columns={this.state.columns}
                            exportUrl={api.cuentasCorrientes.movimientos}
                            title={"Movimientos"}
                            outerSort={outerSort}
                            outerFilter={outerFilter}
                            defaultPageSize={10}
                            depth={1}
                        />
                    </Col>

                    <Col className={'col-7 mt-4'}>
                        <ParadigmaLabeledInput
                            md={[4, 8]}
                            label={"Total Deuda"}
                            error={() => this.getError('totalDeuda')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    type="text"
                                    disabled={true}
                                    value={totalDeuda}
                                    className={'monto'}
                                    dobleSimboloDecimal={true}
                                    selectOnFocus={true}
                                    onBlurComplete={true}
                                    maskOptions={{ prefix: '$ ' }}
                                />}
                        />
                        <ParadigmaLabeledInput
                            md={[4, 8]}
                            label={"Total Pagos"}
                            error={() => this.getError('totalPagos')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    type="text"
                                    disabled={true}
                                    value={totalPagos}
                                    className={'monto'}
                                    dobleSimboloDecimal={true}
                                    selectOnFocus={true}
                                    onBlurComplete={true}
                                    maskOptions={{ prefix: '$ ' }}
                                />}
                        />
                        <ParadigmaLabeledInput
                            md={[4, 8]}
                            label={"Saldo"}
                            error={() => this.getError('saldo')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    type="text"
                                    disabled={true}
                                    value={saldo}
                                    className={'monto'}
                                    dobleSimboloDecimal={true}
                                    selectOnFocus={true}
                                    onBlurComplete={true}
                                    maskOptions={{ prefix: '$ ' }}
                                />}
                        />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default ModalCuentaCorriente;



// WEBPACK FOOTER //
// ./src/views/CuentasCorrientes/CobrosDeudas/ModalCuentaCorriente.js